module.exports = __webpack_public_path__ + "static/assets/90a50cdcc7b6b7a38be8de7e4dc24237.png";